import React, { useContext, useState } from 'react';
import DocsCtx from '../../../../../context/docsContext/docsCtx';
import useTranslate from '../../../../../common/hooks/useTranslate';

import { IDocumentsCell } from '../../../types/IDocumentsCell';

import Icon from '../../../../ui/icon/icon';

import './actionHeaderCell.scss';

const ActionHeaderCell: React.FC<IDocumentsCell> = ({
                                                      multipleDownload,
                                                      field,
                                                      totalNumOfDocuments,
                                                      onClick,
                                                      onDownloadClick,
                                                      onCheck,
                                                      title,
                                                      limit,
                                                      children,
                                                    }) => {
  const { t } = useTranslate();
  const docsCtx = useContext(DocsCtx);

  const [checked, setChecked] = useState(docsCtx.selectedItemsDocIds.length === totalNumOfDocuments || docsCtx.selectedItemsDocIds.length === limit);

  let headerCellStyles;

  if (multipleDownload) {
    headerCellStyles = 'k-link action-header-cell download-padding';
  } else if (field === 'fileType') {
    headerCellStyles = 'k-link action-header-cell align-center';
  } else {
    headerCellStyles = 'k-link action-header-cell';
  }

  return (
    <div className={headerCellStyles} onClick={onClick}>
      <Icon className='check-icon pointer' name={`${checked ? 'fas fa-check-square' : 'far fa-square'}`}
            onClick={() => onCheck(!checked)} />
      {multipleDownload && (
        <>
          <div className='multiple-download' onClick={onDownloadClick}>
            <Icon className='actions-header-cell-icon' name='fas fa-file-zipper' />
            <span className='title'>{docsCtx.selectedItemsIds.length} {t('DOCUMENTS_TABLE.LABEL_DOCUMENTS')}</span>
          </div>
        </>
      )}
      {!multipleDownload && <span>{title}</span>}
      {children}
    </div>
  );
};

export default ActionHeaderCell;
